import store from '@/store'

/**
 * 'Users Guards'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

export default {
  onCreate (to, from, next) {
    let promises = []
    promises.push(store.dispatch('dealers/query', {limit: 1000, sort: 'name ASC'}))
    promises.push(store.dispatch('divisions/query', {limit: 1000}))
    promises.push(store.dispatch('roles/query', {limit: 1000}))
    Promise.all(promises)
      .then(next)
      .catch(next)
  },
  onEdit (to, from, next) {
    let promises = []
    promises.push(store.dispatch('dealers/query', {limit: 1000, sort: 'name ASC'}))
    promises.push(store.dispatch('divisions/query', {limit: 1000}))
    promises.push(store.dispatch('roles/query', {limit: 1000}))
    promises.push(store.dispatch('users/get', to.params))
    promises.push(store.dispatch('permissions/query', {
      limit: 1000,
      'filters[where][userId][eq]': to.params.id,
      'with': 'dealer, branch'
    }))
    Promise.all(promises)
      .then(next)
      .catch(next)
  },
  onList () {

  }
}



// WEBPACK FOOTER //
// ./src/guards/users.guards.js